import CheckoutScreen from '../checkout/CheckoutScreen';
import PlansScreen from '../plans/PlansScreen';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectShowCheckout } from '../plans/plansSlice';

const CheckoutContainer = styled.div`
  display: ${({ showCheckout }) => (showCheckout ? 'block' : 'none')};
`;

const PlanContainer = styled.div`
  display: ${({ showCheckout }) => (showCheckout ? 'none' : 'block')};
`;

const PlanCheckout = (props) => {
  const showCheckout = useSelector(selectShowCheckout)

  return (
    <div>
      <PlanContainer showCheckout={showCheckout}>
        <PlansScreen {...props} />
      </PlanContainer>
      <CheckoutContainer showCheckout={showCheckout}>
        <CheckoutScreen {...props} />
      </CheckoutContainer>
    </div>
  );
};

export default PlanCheckout;
